<h2 class="secondary word-break">
    {{ 'tokens.browser.verifyPincode.verifyPin' | apContent }}
</h2>
<p>{{ 'tokens.browser.verifyPincode.info' | apContent }}</p>

<form [formGroup]="form" (ngSubmit)="submit()">
    <div class="ap-margin-bottom-4 ap-display-block">
        <ap-pincode-input
            data-bb="verify-pincode-input"
            [label]="'tokens.browser.verifyPincode.label' | apContent"
            [formControl]="form.get('verifyPincode') | apFormControl"
            [attr.aria-label]="'tokens.browser.verifyPincode.info' | apContent"
            [messages]="errorMessage"
        >
        </ap-pincode-input>
    </div>

    <div class="ap-margin-bottom-4 ap-display-block">
        <div class="ap-flex ap-flex-row ap-flex-sm-column-reverse ap-flex-1">
            <ap-button (onClick)="goBack()" data-bb="back" variant="secondary" [isDisabled]="buttonsDisabled">
                {{ 'tokens.browser.verifyPincode.back' | apContent }}
            </ap-button>
            <ap-button type="submit" data-bb="submit" [isDisabled]="buttonsDisabled">
                {{ 'tokens.browser.verifyPincode.submit' | apContent }}
            </ap-button>
        </div>
    </div>
</form>
